<template>
  <div class="template-default d-flex flex-column">
    <transition name="fade">
      <div class="blocking-bg d-lg-none" v-if="showMenu" @click="closeMenu" />
    </transition>

    <header
      class="shadow d-flex align-items-center px-lg-5"
      :class="{ 'bg-scroll': bgScroll }"
    >
      <div class="w-100 px-0 d-flex align-items-center">
        <search-all
          @show="showSearch = true"
          @close="showSearch = false"
          class="hide-footer me-2 d-lg-none search-mobile"
          :class="{ showSearch }"
        />
        <router-link
          :to="{ name: 'home' }"
          class="ms-xl-n2 me-xl-5 brand"
          :class="{ showSearch }"
        >
          <img class="img-fluid" src="@/assets/images/logo.png" />
        </router-link>

        <MainMenu
          class="flex-fill d-none d-lg-flex"
          @logout="logoutDialog = true"
        />

        <notification-drop-down
          additional-classes="notification-mobile d-lg-none  ps-3"
        />

        <profile-menu-drop-down
          additional-classes="dropdown-mobile d-lg-none"
          @command="handleCommand"
          @click-menu="handleClose"
          @logout="logoutDialog = true"
        />
      </div>
    </header>

    <button class="btn btn-menu d-lg-none" @click.stop="clickMenuButton">
      <img src="@/assets/images/icons/icon-menu.svg" class="pt-2" />
    </button>

    <MobileMenu
      :open="showMenu"
      @close="closeMenu"
      @logout="logoutDialog = true"
    />

    <main class="flex-fill">
      <div class="position-relative slot-wrapper">
        <slot v-if="!loading" />
      </div>
    </main>
    <!-- </ActionDispatcher> -->
    <app-footer @logout="logoutDialog = true" />

    <confirmation
      v-model="logoutDialog"
      title="Sair"
      text="Deseja mesmo sair?"
      @confirm="logout"
    />

    <el-dialog
      v-model="finish_registration"
      centered
      custom-class="modal-account"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="isMobile ? '85%' : '70%'"
      height="100%"
    >
      <finish-account
        :form="registration"
        @close="finish_registration = false"
      />
    </el-dialog>
  </div>
</template>

<script>
  import NotificationDropDown from "@/components/notifications/NotificationDropDown";
  import ProfileMenuDropDown from "@/components/ProfileMenuDropDown.vue";
  import SearchAll from "@/components/templates/SearchAll";
  import MobileMenu from "@/components/templates/MobileMenu";
  import AppFooter from "@/components/templates/AppFooter";
  import MainMenu from "@/components/templates/MainMenu";
  import FinishAccount from "@/components/FinishAccount";
  import { mapState } from "vuex";
  import get from "lodash/get";

  export default {
    components: {
      NotificationDropDown,
      ProfileMenuDropDown,
      FinishAccount,
      MobileMenu,
      SearchAll,
      AppFooter,
      MainMenu,
    },
    data() {
      return {
        finish_registration: false,
        menuButtonTimeout: null,
        logoutDialog: false,
        popupDialog: false,
        showMenu: false,
        bgScroll: false,
        showSearch: false,
      };
    },
    computed: {
      ...mapState("user", ["messages", "user"]),
      ...mapState(["loading"]),
      user_signature() {
        return get(this.$store, "state.user.user.current_signature", null);
      },
      isMobile() {
        return window.innerWidth < 992;
      },
    },
    mounted() {
      this.dispatchRegistration();
      window.addEventListener("scroll", this.handleScroll);
    },
    watch: {
      $route: function () {
        if (this.$route.name != "login") {
          this.dispatchRegistration();
        }
      },
    },
    methods: {
      handleClose() {
        this.$refs.mobileDD.handleClose();
      },
      handleCommand(command) {
        if (command == "logout") this.logoutDialog = true;
      },
      dispatchRegistration() {
        this.$store.dispatch("user/registration_asks").then(({ results }) => {
          if (this.user_signature) {
            const form = results.find(
              (i) => i.signatures.indexOf(this.user_signature.id) > -1
            );

            if (!form || !form.answerds || !form.answerds.length) return;

            let answered_forms = [];

            answered_forms = form.answerds.map((i) => i.id);

            if (answered_forms.indexOf(this.user_signature.id) == -1) {
              this.registration = form;
              this.finish_registration = true;
            }
          }
        });
      },
      handleScroll() {
        if (window.scrollY > 10) {
          this.bgScroll = true;
        } else if (window.scrollY < 10) {
          this.bgScroll = false;
        }
      },
      clickMenuButton() {
        this.setMenuVisibility(!this.showMenu);
      },
      setMenuVisibility(visibility) {
        if (this.menuButtonTimeout) {
          clearTimeout(this.menuButtonTimeout);
        }
        this.menuButtonTimeout = setTimeout(() => {
          this.showMenu = visibility;
        }, 150);
      },
      logout() {
        this.$store.dispatch("logout").then(() => {
          this.$router.push({ name: "login" });
        });
      },
      clickMenu() {
        this.closeMenu();
      },
      closeMenu() {
        this.showMenu = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .template-default {
    min-height: 100vh;
    display: flex;

    @media screen and (max-width: 575px) {
      padding-top: 56px;
    }

    :deep(.modal-account) {
      background-color: #0f0f0f;
      border: 1px solid #4f4f4f;
    }

    &.sale {
      background: #e63946;

      :deep(footer) * {
        color: rgb(255, 255, 255) !important;
      }
    }

    .btn-menu {
      position: fixed;
      width: 72px;
      top: 4px;
      z-index: 4;
    }

    .dropdown-mobile {
      position: fixed;
      width: 72px;
      top: 0;
      z-index: 4;
      right: 0px !important;
    }
    .notification-mobile {
      position: fixed;
      width: 72px;
      max-height: 20px;
      top: 8px;
      z-index: 4;
      right: 60px !important;
    }

    .search-mobile {
      position: fixed;
      width: 72px;
      max-height: 20px;
      top: 12px;
      z-index: 4;
      left: 60px !important;

      &.showSearch {
        width: 200px;

        @media (max-width: 320px) {
          width: 130px;
        }
      }
    }

    .blocking-bg {
      position: fixed;
      z-index: 3;
      background: rgba(0, 10, 20, 0.5);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    i {
      font-size: 24px;
      min-width: 46px;

      &.menu {
        font-size: 32px;
        line-height: 44px;
        color: rgba(51, 51, 51, 0.6);
      }
    }

    .open-submenu {
      .icon-outline-chevron-right-small-circle {
        transform: rotate(90deg);
      }
    }

    main {
      width: 100%;
      position: relative;
    }

    header {
      min-height: 76px;
      @media screen and (max-width: 768px) {
        min-height: 55px;
      }

      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      flex: 1 1 auto;
      z-index: 3;

      background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);

      &.bg-scroll {
        background: rgba($color: #000000, $alpha: 0.85);
        backdrop-filter: blur(10px);
      }

      @media screen and (min-width: 992px) {
        z-index: 5;

        :deep(.btn) {
          font-family: "Inter";
          color: #fff !important;
          font-size: 16px;
        }
      }

      @media screen and (max-width: 575px) {
        right: 0;
        top: 0;
        left: 0;
        z-index: 3;
        position: fixed;
      }

      a {
        font-weight: bold;
        font-size: 12px;
        color: #fff;
      }

      .brand {
        @media screen and (max-width: 991px) {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          font-weight: bold;

          &.showSearch {
            display: none;
          }
        }

        @media screen and (min-width: 300px) and (max-width: 374px) {
          width: 70px;
          left: 47%;
        }
        width: 110px;
      }

      i {
        font-size: 20px;
      }
    }

    .slot-wrapper {
      transition: 0.3s padding ease;
    }

    .submenu {
      width: 100%;

      a {
        padding-left: 32px !important;
      }
    }
  }

  .wrapper-dropdown {
    background: #0b0b0b;
    border: 1px solid transparent;

    padding: 1rem 0 !important;
    margin-top: 5px;

    right: -80px !important;
    // height: 80vh;
    max-height: 540px;

    & :deep(>) * {
      padding-left: 5rem !important;
      padding-right: 5rem !important;
    }

    hr {
      background: white;
      height: 2px;
    }

    :deep(.el-dropdown__popper) {
      background: red;
    }

    :deep(.el-dropdown-menu__item) {
      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      // &,
      // & * {
      //   // color: #fff;
      // }

      &:hover {
        background-color: #333333 !important;
      }

      i {
        font-size: 20px;
        color: black;
        margin-right: 1rem;
      }
    }
  }
</style>
